import React from "react";
import Hidden from "@material-ui/core/Hidden";
import Grid from "@material-ui/core/Grid";
import { connect } from "react-redux";
import useStyles from "../style";
import PropTypes from 'prop-types';
import SearchRegionField from "./Fields/SearchRegionField";
import SearchBranchField from "./Fields/SearchBranchField";
import SearchPeriodField from "./Fields/SearchPeriodFilter";
import SearchFarmField from "./Fields/SearchFarmField";
import SearchTransporterField from "./Fields/SearchTransporterField";
import SearchButton from "./Fields/SearchButton";
import SearchOperationFilter from "./Fields/SearchOperationFilter";
import SearchOCPanel from "../../SearchOCPanel";
import SearchOCField from "../../SearchOCPanel/SearchOCField";
import FilterAssignOnValidate from "./Fields/FilterAssignOnValidate";
import FilterAssignOnAdd from "./Fields/FilterAssignOnAdd";
import FilterOcReseted from "./Fields/FilterOcReseted";
// import CheckFilterHasDocuments from "./Fields/CheckFilterHasDocuments";
import { useLocation } from "react-router-dom";

function TabHeader({
  mainGroup,
  groups,
  action,
  farms,
  filteredBranches,
  filteredBranchRegions,
  setPeriod,
  setBranchFilter,
  onFilterOC,
  setNotificationString,
  setNoCache,
  filteredPeriod,
  setFilteredBranches,
  setTransportersFilter,
  filteredOperation,
  filteredOCsHasDocument,
  setFilteredOCsHasDocument,
  setFilteredOperation,
  filterState,
  clearLoadingOrder,
  resetLoadingOrderDocument,
  setRegionFilter,
  setFilteredBranchRegions,
  filterRegionState,
  setAssignOnValidate,
  filterAssignOnValidate,
  setAssignOnAdd,
  filterAssignOnAdd,
  filterOcReseted,
  setFilterOcReseted
}) {
  const classes = useStyles();

  const handleSearch = () => {
    setPeriod(filteredPeriod);
    setBranchFilter(filterState);
    setRegionFilter(filterRegionState);
    setFilteredBranches(filterState);
    setFilteredBranchRegions(filterRegionState);
    setTransportersFilter();
    setNotificationString(filteredBranches);
    setFilteredOperation(filteredOperation);
    setFilteredOCsHasDocument({ filteredOCsHasDocument, persist: true });
    setAssignOnValidate(filterAssignOnValidate);
    setAssignOnAdd(filterAssignOnAdd);
    setFilterOcReseted(filterOcReseted);
  };

  const location = useLocation();

  const isExchangeDocumentsArea = () =>
    action.indexOf("trocar-documentos") !== -1 || action.indexOf("/cargill-transports") !== -1;

  const canSearchFarms = () => ["farmer"].indexOf(mainGroup) !== -1;

  const isFarmer = () => mainGroup === "farmer";
  const isFarmerOrWarehouse = () => ["farmer", "warehouse"].indexOf(mainGroup) !== -1;

  const canSearchBranchRegions = () =>
    ["support", "backoffice"].indexOf(mainGroup) !== -1;

  const canSearchBranches = () =>
    ["transporter", "support", "backoffice", "warehouse"].indexOf(mainGroup) !== -1;

  const canSearchOperationTypes = () =>
    ["transporter", "support", "backoffice"].indexOf(mainGroup) !== -1 &&
    location.pathname !== '/trocar-documentos/validar-documentos-transportadoras';

  const canSearchOC = () =>
    ["support", "backoffice", "transporter", "farmer", "warehouse"].indexOf(mainGroup) !== -1;

  const canResetOC = () =>
    groups.indexOf("backoffice") !== -1;

  const canSearchPeriod = () => ["support", "backoffice"].indexOf(mainGroup) !== -1;
  const canSearchTransporter = () => ["transporter"].indexOf(mainGroup) !== -1;

  const canFilterAssign = () =>
    ["support", "backoffice"].indexOf(mainGroup) !== -1;

  const canFilterOcReseted = () =>
    ["support", "backoffice"].indexOf(mainGroup) !== -1;

  return (
    isExchangeDocumentsArea() && (
      <Grid container className={classes.filterBox}>
        {canSearchTransporter() && (
          <Grid md={3} sm={12} xs={12} lg={3} item className={classes.ocBox}>
            <SearchTransporterField mainGroup="transporter" />
          </Grid>
        )
        }
        {canSearchOperationTypes() && (
          <Grid
            item
            xs={12}
            sm={12}
            md={1}
            lg={1}
            className={classes.filterGrid}
          >
            <SearchOperationFilter/>
          </Grid>
        )}
        {canSearchBranchRegions() && (
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={2}
            className={classes.branchFilter}
          >
            <SearchRegionField
              mainGroup={mainGroup}
              className={classes.filter}
              filteredBranchRegions={filteredBranchRegions}
            />
          </Grid>
        )}
        {canSearchBranches() && (
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={2}
            className={classes.branchFilter}
          >
            <SearchBranchField
              mainGroup={mainGroup}
              className={classes.filter}
              filteredBranches={filteredBranches}
            />
          </Grid>
        )}
        {canFilterAssign() && (
            <FilterAssignOnValidate
              mainGroup={mainGroup}
              filterAssignOnValidate={filterAssignOnValidate}
              action={action}
            />
        )}
        {canFilterAssign() && (
            <FilterAssignOnAdd
              mainGroup={mainGroup}
              filterAssignOnAdd={filterAssignOnAdd}
              action={action}
            />
        )}
        {canFilterOcReseted() && (
            <FilterOcReseted
              mainGroup={mainGroup}
              filterOcReseted={filterOcReseted}
              action={action}
            />
        )}
        {canSearchOC() && (
          <></>
          /* <Grid
            item
            xs={12}
            sm={12}
            md={2}
            lg={2}
          >
            <CheckFilterHasDocuments
              mainGroup={mainGroup}
              className={classes.filter}
            />
          </Grid> */
        )}
        {canSearchFarms() && (
          <Grid
            item
            xs={12}
            sm={12}
            md={5}
            lg={3}
            className={classes.farmFilter}
          >
            <SearchFarmField farms={farms} mainGroup={mainGroup} />
          </Grid>
        )}
        {canSearchPeriod() &&
          (<SearchPeriodField
            action={action}
            mainGroup={mainGroup}
            className={classes.filter}
          />)
        }
        <Hidden smDown>
          {!isFarmer() &&
            <Grid
              xs={12}
              sm={12}
              md={2}
              lg={2}
              item
              className={classes.buttonBox}
            >
              <SearchButton
                handleSearch={handleSearch}
                className={classes.button}
                mainGroup={mainGroup}
              />
            </Grid>
          }
        </Hidden>
        {!isFarmer() &&
          <Hidden smUp>
            <Grid className={classes.smButtonBox}>
              <SearchButton
                handleSearch={handleSearch}
                className={classes.button}
                mainGroup={mainGroup}
              />
            </Grid>
          </Hidden>
        }
        {canSearchOC() && (
          <Grid md={3} sm={12} xs={12} lg={3} item className={classes.ocBox}>
            {
              isFarmerOrWarehouse() ?
                <SearchOCField
                  handleSearch={loadingOrderNumber => onFilterOC && onFilterOC(loadingOrderNumber)} /> :
                <SearchOCPanel
                  clearLoadingOrder={clearLoadingOrder}
                  resetLoadingOrderDocument={resetLoadingOrderDocument}
                  canResetOC={canResetOC()} />
            }
          </Grid>
        )}

      </Grid>
    )
  );
}

const mapDispatch = (dispatch) => ({
  setAssignOnValidate: (payload) => dispatch.loadingOrders.setAssignOnValidateAsync(payload),
  setAssignOnAdd: (payload) => dispatch.loadingOrders.setAssignOnAddAsync(payload),
  setFilterOcReseted: (payload) => dispatch.loadingOrders.setFilterOcResetedAsync(payload),
  setBranchFilter: (payload) => dispatch.branches.setFilteredAsync(payload),
  setRegionFilter: (payload) => dispatch.branches.setFilteredRegionsAsync(payload),
  setFilteredBranches: (payload) => dispatch.branches.setFilteredBranches(payload),
  setFilteredBranchRegions: (payload) => dispatch.branches.setFilteredBranchRegions(payload),
  setTransportersFilter: () => dispatch.transporters.setTransportersStringAsync(),
  setNotificationString: (payload) => dispatch.notifications.setBranchIdsAsync(payload.map((i) => i.value).join()),
  setPeriod: (payload) => dispatch.branches.setPeriodAsync(payload),
  setNoCache: (payload = null) => dispatch.navigation.setNoCache(payload),
  clearLoadingOrder: (id, reason) => dispatch.loadingOrders.clearAsync({ id, reason }),
  resetLoadingOrderDocument: (ocNumber) => dispatch.loadingOrders.resetOCNumberAsync(ocNumber),
  setFilteredOperation: operation => dispatch.loadingOrders.setFilteredOperation(operation),
  setFilteredOCsHasDocument: (payload) => dispatch.loadingOrders.setFilteredOCsHasDocument(payload),
});

const mapState = (state) => ({
  filteredBranches: state.branches.filteredBranches,
  filteredBranchRegions: state.branches.filteredBranchRegions,
  filteredTransporters: state.transporters.filteredTransporters,
  branchNumbers: state.notifications.branchNumbers,
  filterState: state.branches.filterState,
  filterRegionState: state.branches.filterRegionState,
  filteredOperation: state.loadingOrders.filterState,
  filteredOCsHasDocument: state.loadingOrders.filteredOCsHasDocument,
  transportersFilterState: state.transporters.filterState,
  filterAssignOnValidate: state.loadingOrders.filterAssignOnValidate,
  filterAssignOnAdd: state.loadingOrders.filterAssignOnAdd,
  filterOcReseted: state.loadingOrders.filterOcReseted,
});

TabHeader.propTypes = {
  onFilterOC: PropTypes.func.isRequired,
  action: PropTypes.string.isRequired,
  groups: PropTypes.array.isRequired,
  mainGroup: PropTypes.string.isRequired,
};

export default connect(mapState, mapDispatch)(TabHeader);
